import React from 'react';
import { LangContext } from '../contexts/lang.context';
import { UserInfoContext } from '../contexts/userInfo.context';
import { DispatchContext } from '../contexts/userInfo.context';
import { HintText, SectionTitle, MyButton } from './ui';
import { Checkbox, FormControl, FormControlLabel, FormGroup } from '@material-ui/core';
import { ActionTypes } from '../actions';
import { Symptoms } from '../constants';
import * as model from '../models/api';

export const SymptomSection: React.FC = () => {
  const { SYMPTOM_SECTION, SYMPTOM, BUTTON } = React.useContext(LangContext).currentLangData;
  const { symptoms } = React.useContext(UserInfoContext);
  const dispatch = React.useContext(DispatchContext);

  const [isProgress, setIsProgress] = React.useState<boolean>(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const key: string = e.target.name;
    const checked: boolean = symptoms[key];
    const updatedSymptoms = { ...symptoms, [key]: !checked };
    dispatch({ type: ActionTypes.toggleSymptom, payload: updatedSymptoms });
  };

  const handleFormSubmit = async () => {
    try {
      setIsProgress(true);
      const isSuccess = await model.updateSymptom(symptoms);
      if (isSuccess === false) {
        console.log('updateSymtom fail');
        return;
      }
      console.log('updateSymtom success');
    } catch (error) {
      console.log(error);
    } finally {
      setIsProgress(false);
    }
  };

  const formControlLabels = Object.values(Symptoms).map((symptomValue) => {
    const checked = symptoms[symptomValue];
    const key: keyof typeof SYMPTOM = symptomValue;

    return (
      <FormControlLabel
        key={symptomValue}
        control={
          <Checkbox
            checked={checked || false}
            onChange={handleCheckboxChange}
            name={symptomValue}
          />
        }
        label={SYMPTOM[key]}
      />
    );
  });

  return (
    <>
      <HintText text={SYMPTOM_SECTION.hint} />
      <SectionTitle title={SYMPTOM_SECTION.title} />

      <FormControl component="fieldset">
        <FormGroup>{formControlLabels}</FormGroup>
        <MyButton
          isProgress={isProgress}
          onClick={handleFormSubmit}
          text={isProgress ? BUTTON.saving : BUTTON.submit}
        />
      </FormControl>
    </>
  );
};
